import { render } from "./GroupItem.vue?vue&type=template&id=16d7d0b4&scoped=true"
import script from "./GroupItem.vue?vue&type=script&lang=js"
export * from "./GroupItem.vue?vue&type=script&lang=js"

import "./GroupItem.vue?vue&type=style&index=0&id=16d7d0b4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16d7d0b4"]])

export default __exports__